import {TranslatorScope} from '../../../locale/types'
import {LocaleOptions} from '../../../utils/i18n'

export type ChargeErrorLike = {
  response?: {
    status?: number
    data?: {type?: unknown, limit?: unknown, message?: unknown, status?: unknown}
  }
}

// exsportia-server#4038: a refused Opn charge answers 400 with the reason; over the venue's
// per-charge limit it is typed AMOUNT_OVER_CARD_LIMIT with the limit in THB.
export const chargeErrorMessage = (
  l: (scope: TranslatorScope, options?: LocaleOptions) => string,
  error: ChargeErrorLike,
): string | undefined => {
  if (error.response?.status !== 400) {
    return undefined
  }
  const {type, limit, message} = error.response.data || {}
  if (type === 'AMOUNT_OVER_CARD_LIMIT') {
    const value = Number(limit)
    return Number.isFinite(value)
      ? l('checkout-charge-over-limit', {limit: value.toLocaleString('en-US')})
      : typeof message === 'string' ? message : undefined
  }
  return typeof message === 'string' && message.length > 0 ? message : undefined
}
